import { Component } from '@angular/core';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';

@Component({
  selector: 'app-email-verification',
  imports: [TranslatePipe],
  templateUrl: './email-verification.component.html',
  styleUrl: './email-verification.component.scss',
})
export class EmailVerificationComponent {
  public email = '';

  constructor() {}

  ngOnInit() {
    const tempEmail = localStorage.getItem('email');
    if (tempEmail && tempEmail.length > 0) {
      this.email = tempEmail;
      localStorage.removeItem('email');
    }
  }
}
